import { useSnackbar } from 'notistack';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
} from '@mui/material';

import { Account } from '@/types';
import { useDeleteAccountMutation } from '@/services';

export interface DeleteAccountProps extends DialogProps {
  account: Account;
  onClose(): void;
}

const DeleteAccount: React.FC<DeleteAccountProps> = ({ account, onClose, ...props }) => {
  const { enqueueSnackbar } = useSnackbar();

  const [deleteAccount, deleteAccountResponse] = useDeleteAccountMutation();

  async function handleDeleteAccount() {
    try {
      await deleteAccount(account).unwrap();

      onClose();
    } catch (error) {
      enqueueSnackbar(error.data, { variant: 'error' });
    }
  }

  return (
    <Dialog fullWidth {...props}>
      <DialogTitle fontWeight="bold">{account?.bank_name}</DialogTitle>

      <DialogContent dividers>
        <DialogContentText>Вы действительно хотите удалить "{account?.bank_name}"?</DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button
          color="secondary"
          variant="outlined"
          size="small"
          disabled={deleteAccountResponse.isLoading}
          onClick={onClose}
        >
          Закрыть
        </Button>

        <Button
          variant="contained"
          disabled={deleteAccountResponse.isLoading}
          size="small"
          onClick={handleDeleteAccount}
        >
          Да
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteAccount;
